import { createGlobalStyle } from "styled-components"

const PdpGlobalStyle = createGlobalStyle`
   iframe#chat-button {
      @media(max-width: 701px) {
        bottom: 55px !important;
      }
    }
   .product-page {
   @media(max-width: 350px){
    iframe#chat-button {
        bottom: 180px !important;
        right: 0 !important;
        left: unset !important;
      }
   }
   @media(min-width: 350px){
    iframe#chat-button {
        bottom: 160px !important;
        right: 0 !important;
        left: unset !important;
      }
   }
    @media(min-width: 400px){
      iframe#chat-button {
        bottom: 150px !important;
      }
    }
    @media(min-width: 450px){
      iframe#chat-button {
        bottom: 140px !important;
      }
    }
    @media(min-width: 550px){
      iframe#chat-button {
        bottom: 130px !important;
      }
    }
    @media(min-width: 600px){
      iframe#chat-button {
        bottom: 60px !important;
      }
    }
     @media(max-width: 600px) {
        .cookieBanner {
          bottom: 80px;
          width: 100%;
          left: 0;
         }
        }
     @media(max-width: 700px) {
        .cookieBanner {
          width: 100%;
          left: 0;
         }
        }
        @media(min-width: 701px){
        iframe#chat-button {
            bottom: 50px !important;
            right: 72px !important;
         }
        }
        @media(min-width: 768px){
          iframe#chat-window {
            bottom: 140px !important;
            right: 50px !important;
            left: unset !important;
          }
        }
     }
     .product-page.seen {
        iframe#chat-button {
          bottom: 50px !important;
          right: 0px !important;
          @media(min-width: 701px) {
            bottom: 0 !important;
        }
        @media(min-width: 768px){
          iframe#chat-window {
            bottom: 90px !important;
            right: 0px !important;
            left: unset !important;
          }
        }
      }
    }
`

export default PdpGlobalStyle
